import React from "react";
import OrderSummaryRow from "./OrderSummaryRow";
import ChangeTireSelector from "./ChangeTireSelector";
import "./styles.scss";

const OrderSummary = ({
  items,
  changeFlow,
  changingTireItemId,
  onStartChangeTire,
  onCancelChangeTire,
  onApplyReplacement,
  onRemove,
  onAddBack,
  changeDisabled,
  changeDisabledHint,
}) => {
  const lineItems = (items && items.line_items) || [];

  return (
    <div className="order-summary-section">
      <h3 className="order-summary-section__title">order summary</h3>
      <ul className="order-summary-section__list">
        {lineItems.map((item, idx) => {
          const itemKey = item.id ?? item.sku ?? idx;
          const removed = !!item.removed;
          const isChanging =
            !removed && item.id != null && item.id === changingTireItemId;
          const recType = item.recommendation_type || "none";
          const rowOnChange =
            !removed && recType === "change" && !isChanging
              ? onStartChangeTire
              : null;
          const rowOnRemove =
            !removed && recType === "remove" ? onRemove : null;
          return (
            <li key={itemKey} className="order-summary-section__item">
              <OrderSummaryRow
                item={item}
                removed={removed}
                onChange={rowOnChange}
                onRemove={rowOnRemove}
                onAddBack={onAddBack}
                changeDisabled={changeDisabled}
                changeDisabledHint={changeDisabledHint}
              />
              {isChanging && (
                <div className="order-summary-section__change-tire">
                  <ChangeTireSelector
                    item={item}
                    changeFlow={changeFlow}
                    onCancel={onCancelChangeTire}
                    onApply={onApplyReplacement}
                    onRetry={onStartChangeTire}
                  />
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default OrderSummary;
